import styled from 'styled-components';

const NotFoundWrapper = styled('div')`
  display: flex;
  flex: 1 1 auto;
  align-items: center;
  justify-content: center;
  padding: 0;
`;

export default NotFoundWrapper;
